import Vue from 'vue'

var _vueInit = Vue.prototype._init
var beforeInitCbs = []

Vue.prototype._init = function (options) {
    for (var i = 0; i < beforeInitCbs.length; i++) {
        beforeInitCbs[i].call(this, options)
    }
    _vueInit.apply(this, arguments)
}

export default function beforeInit(fn) {
    beforeInitCbs.push(fn)
}
